/* Optional, not installed in build 1628. No persistence or implicit uploads. */
const ENDPOINT = '/api/ocr-jobs.php';
const STATES = new Set(['queued', 'running', 'succeeded', 'failed', 'cancelled', 'expired']);
export class LightOnClient {
  constructor({ownerId, csrfToken, fetchImpl = globalThis.fetch, wait = ms => new Promise(r => setTimeout(r, ms))}) {
    if (typeof ownerId !== 'string' || !ownerId || typeof csrfToken !== 'string' || !csrfToken) throw new Error('Session enseignante requise.');
    this.ownerId = ownerId; this.csrfToken = csrfToken; this.fetch = fetchImpl; this.wait = wait;
    this.epoch = 0; this.controller = null; this.jobId = null;
  }
  dispose() { this.epoch++; this.controller?.abort(); this.controller = null; this.jobId = null; }
  async request(body, signal) {
    const response = await this.fetch(ENDPOINT, {method:'POST', credentials:'same-origin', cache:'no-store', signal,
      headers:{'Content-Type':'application/json', 'X-CSRF-Token':this.csrfToken},
      body:JSON.stringify({...body, expectedOwnerId:this.ownerId})});
    let data; try { data = await response.json(); } catch { throw new Error('Réponse OCR illisible.'); }
    if (!response.ok) throw new Error(typeof data?.error === 'string' ? data.error : 'Service OCR indisponible.');
    if (!data || typeof data.jobId !== 'string' || !data.jobId || !STATES.has(data.state)) throw new Error('État OCR invalide.');
    if (data.state === 'succeeded' && (typeof data.text !== 'string' || !data.text.trim() || data.text.length > 20000 || !Number.isInteger(data.pageCount) || data.pageCount < 1 || data.pageCount > 5)) throw new Error('Résultat OCR invalide.');
    return data;
  }
  async create({documentBase64, mimeType, consent, requestId}) {
    if (consent !== true) throw new Error('Confirmez la transmission au serveur Copiveo et au VPS OCR.');
    if (!/^[a-f0-9]{32}$/.test(requestId || '')) throw new Error('Identifiant de création requis.');
    if (this.controller || this.jobId) throw new Error('Une extraction est déjà suivie.');
    if (!['application/pdf','image/png','image/jpeg'].includes(mimeType) || typeof documentBase64 !== 'string' || !documentBase64 || documentBase64.length > 5592408) throw new Error('Document invalide ou supérieur à 4 Mo.');
    const token = ++this.epoch, controller = new AbortController(); this.controller = controller;
    try {
      const job = await this.request({action:'create', requestId, documentBase64, mimeType}, controller.signal);
      if (token !== this.epoch) return null;
      this.jobId = job.jobId; return job;
    } finally { if (token === this.epoch) this.controller = null; }
  }
  async follow(onState) {
    if (!this.jobId || this.controller) throw new Error('Aucune extraction disponible.');
    const token = ++this.epoch, id = this.jobId, controller = new AbortController(); this.controller = controller;
    try {
      while (token === this.epoch) {
        const job = await this.request({action:'status', jobId:id}, controller.signal);
        if (token !== this.epoch) return null;
        if (job.jobId !== id) throw new Error('Le résultat ne correspond pas à cette extraction.');
        onState?.(job);
        if (token !== this.epoch) return null;
        if (!['queued','running'].includes(job.state)) return job;
        await this.wait(5000);
      }
      return null;
    } finally { if (token === this.epoch) this.controller = null; }
  }
  async cancel() {
    const id = this.jobId; this.dispose();
    if (!id) return null;
    // Deliberate user action, separate from merely leaving the view. No automatic retry.
    return this.request({action:'cancel', jobId:id});
  }
}
